var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0071 7.5C13.0071 4.46001 10.54 1.99286 7.5 1.99286C4.46001 1.99286 1.99286 4.46001 1.99286 7.5C1.99286 10.54 4.46001 13.0071 7.5 13.0071C10.54 13.0071 13.0071 10.54 13.0071 7.5ZM0.15 7.5C0.15 3.43641 3.43641 0.15 7.5 0.15C11.5636 0.15 14.85 3.43641 14.85 7.5C14.85 11.5636 11.5636 14.85 7.5 14.85C3.43641 14.85 0.15 11.5636 0.15 7.5Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10028 6.71814V6.86814H8.25028H10.7146C11.071 6.86814 11.3681 7.16526 11.3681 7.52171C11.3681 7.87815 11.071 8.17528 10.7146 8.17528H8.25028H8.10028V8.32528V10.7146C8.10028 11.071 7.80315 11.3681 7.44671 11.3681C7.09026 11.3681 6.79314 11.071 6.79314 10.7146V8.32528V8.17528H6.64314H4.28599C3.92955 8.17528 3.63242 7.87815 3.63242 7.52171C3.63242 7.16526 3.92955 6.86814 4.28599 6.86814H6.64314H6.79314V6.71814V4.28599C6.79314 3.92955 7.09026 3.63242 7.44671 3.63242C7.80315 3.63242 8.10028 3.92955 8.10028 4.28599V6.71814Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.916ff773acdced0f5130bd5199fbe0a2.svg";
export { ForwardRef as ReactComponent };